import React from 'react';
import PropTypes from 'prop-types';
import styles from './Divider.module.scss';

export default function Divider(props) {
  return (
    <div
      style={{
        marginLeft: props.margin + 'px',
        marginRight: props.margin + 'px',
      }}
      className={styles.divider}
    />
  );
}

Divider.propTypes = {
  margin: PropTypes.number,
};